import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

/**
 * Labelled text/password input in the Sign In v2 style.
 * `right` renders next to the label (e.g. a "Forgot password?" link).
 */
export default function AuthField({
  id,
  label,
  type = "text",
  value,
  onChange,
  error,
  hint,
  optional,
  right,
  autoComplete,
  placeholder,
  autoFocus,
}) {
  const [show, setShow] = useState(false);
  const isPw = type === "password";
  const errId = `${id}-err`;

  return (
    <div className="auth-fl">
      {right ? (
        <div className="auth-lh">
          <label htmlFor={id}>{label}</label>
          {right}
        </div>
      ) : (
        <label htmlFor={id}>
          {label}
          {optional && <span className="auth-opt"> (optional)</span>}
        </label>
      )}
      <div className={`auth-in${isPw ? " is-pw" : ""}${error ? " is-bad" : ""}`}>
        <input
          id={id}
          name={id}
          type={isPw && show ? "text" : type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete={autoComplete}
          placeholder={placeholder}
          autoFocus={autoFocus}
          aria-invalid={error ? "true" : undefined}
          aria-describedby={error ? errId : undefined}
        />
        {isPw && (
          <button
            type="button"
            className="auth-eye"
            onClick={() => setShow((v) => !v)}
            aria-label={`${show ? "Hide" : "Show"} password`}
          >
            {show ? <VisibilityOffIcon sx={{ fontSize: 18 }} /> : <VisibilityIcon sx={{ fontSize: 18 }} />}
          </button>
        )}
      </div>
      {error ? (
        <small className="auth-err" id={errId}>
          {error}
        </small>
      ) : (
        hint && <small>{hint}</small>
      )}
    </div>
  );
}
